import React from 'react';

const iconMoneyIn = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6310_15281)">
      <path
        d="M20.0337 6.0028H3.14875C2.7225 6.0028 2.365 5.63891 2.365 5.20504C2.365 4.77117 2.7225 4.40728 3.14875 4.40728H17.6825C18.3287 4.40728 18.865 3.87544 18.865 3.20364C18.865 2.53184 18.3425 2 17.6825 2H3.14875C1.41625 2 0 3.44157 0 5.20504V18.795C0 20.5584 1.41625 22 3.14875 22H20.0475C21.1337 22 22.0138 21.1043 22.0138 19.9986V8.0042C22.0138 6.89853 21.1337 6.0028 20.0475 6.0028H20.0337ZM19.3738 10.4955L12.8287 17.1575H16.7887C17.4625 17.1575 18.0125 17.7173 18.0125 18.4031C18.0125 19.0889 17.4625 19.6487 16.7887 19.6487H9.88625C9.2125 19.6487 8.6625 19.0889 8.6625 18.4031V11.3772C8.6625 10.6914 9.2125 10.1316 9.88625 10.1316C10.56 10.1316 11.11 10.6914 11.11 11.3772V15.408L17.655 8.74598C18.1362 8.25612 18.9062 8.25612 19.3875 8.74598C19.8687 9.23583 19.8687 10.0196 19.3875 10.5094L19.3738 10.4955Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6310_15281">
        <rect width="22" height="20" fill="white" transform="translate(0 2)" />
      </clipPath>
    </defs>
  </svg>
);

export default iconMoneyIn;
